import React, { useEffect } from "react";
import DetailsWorkFlows from "components/WorkFlow/DetailsWorkFlows";
import ListWorkFlows from "components/WorkFlow/ListWorkFlows";
import { getWorkFlows } from "actions/WorkFlowActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/UI/Loader"

const WorkFlow = () => {
  const { currentProject } = useSelector(state => state.auth);
  const { isLoadingFetch, isLoadingStages } = useSelector(state => state.workFlow);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentProject) {
      dispatch(getWorkFlows(currentProject.id));
    }
  }, [dispatch, currentProject]);

  const getStageSection = () => {
    if (isLoadingStages) return <Loader/>
    return (
      <div className="h-full w-3/4 p-10">
        <DetailsWorkFlows/>
      </div>
    )
  }

  return (
    <div className="flex flex-col w-full h-screen">
      <div className="bg-[#000000] rounded-t-lg h-[59px] w-full flex items-center justify-between px-4">
        <label className="text-[#ffffff] text-[16px] font-[Gravity] font-bold">
          Flujos de trabajo
        </label>
      </div>
      <div className={`flex flex-row items-start w-full h-3/4 overflow-x-scroll overflow-y-scroll shadow-scroll-x`}>
        {
          isLoadingFetch ? (
            <Loader type="truck" />
          ) : (
            <>
              <div className="h-full w-1/4 p-5 overflow-hidden">
                <ListWorkFlows />
              </div>
              {getStageSection()}
            </>
          )
        }
      </div >
    </div >
  )
}

export default WorkFlow;